'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const DONATION_EVENT_PREFIX = '/donation/event';
const EVENT_PREFIX = '/event';

/** URL 정규화 대상 경로 (기존 /event/* → /donation/event/*로 이전된 페이지들) */
const NORMALIZE_TARGETS = [
  '/donation/event/localfesta',
  '/donation/event/kb-check-card',
];

/**
 * /donation/event/* URL을 /event/*로 정규화하는 공통 컴포넌트
 * - redirect로 /donation/event/... 에 도달한 페이지의 주소창을 /event/...로 되돌림
 */
export const DonationEventUrlNormalizer = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname?.startsWith(DONATION_EVENT_PREFIX)) return;
    if (!NORMALIZE_TARGETS.some((target) => pathname.startsWith(target)))
      return;

    const cleanPath = pathname.replace(DONATION_EVENT_PREFIX, EVENT_PREFIX);
    const currentUrl = new URL(window.location.href);
    const cleanUrl = `${cleanPath}${currentUrl.search}${currentUrl.hash}`;

    if (window.location.pathname.startsWith(DONATION_EVENT_PREFIX)) {
      window.history.replaceState(
        { ...window.history.state, as: cleanUrl, url: cleanUrl },
        '',
        cleanUrl,
      );
    }
  }, [pathname]);

  return null;
};
